export const prepareParams = ({
  category,
  pageNumber,
  pageSize,
  searchKeyword,
  startDate,
  endDate,
}) => {
  return {
    category:
      category === "all" || category === "archived" ? undefined : category,
    startDate: startDate?.format("YYYY-MM-DD 00:00:00"),
    endDate: endDate?.format("YYYY-MM-DD 23:59:00"),
    searchKeyword: searchKeyword ?? "",
    pageNumber: pageNumber,
    pageSize: pageSize,
    isArchived: category === "archived" ? true : false,
  };
};
